/**
 * TopBar Component
 * Full-width horizontal bar with logo, workspace selector, and actions
 */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionIcon } from '@mantine/core';
import { IconMenu2 } from '@tabler/icons-react';

import { BrandLogo } from '@/components/common/BrandLogo';
import { TopBarActions } from './TopBarActions';
import type { TopBarProps } from './TopBar.types';
import styles from './TopBar.module.css';

export function TopBarDivider() {
  return <div className={styles.topBarDivider} />;
}

export const TopBar = memo(function TopBar({
  workspaceSelector,
  actions,
  onMobileMenuClick,
  hideLogo,
}: TopBarProps) {
  const { t } = useTranslation();

  return (
    <header className={styles.topBar}>
      <div className={styles.leftSection}>
        {onMobileMenuClick && (
          <div className={styles.mobileMenuButton}>
            <ActionIcon
              variant="subtle"
              size="lg"
              onClick={onMobileMenuClick}
              aria-label={t('appShell.sidebar.toggleMenu')}
            >
              <IconMenu2 size={22} />
            </ActionIcon>
          </div>
        )}
        {!hideLogo && (
          <div className={styles.logo}>
            <BrandLogo
              size="sm"
              showLabel
              showTagline
              iconLeadWidth="var(--app-sidebar-width)"
            />
          </div>
        )}
      </div>
      {workspaceSelector && (
        <div className={styles.centerSection}>{workspaceSelector}</div>
      )}
      <div className={styles.rightSection}>{actions || <TopBarActions />}</div>
    </header>
  );
});
